import React from 'react';
import { useSelector } from 'react-redux';
import { stateGlobal } from '../../interfaces/Global';
import { WhatsAppOutlined } from '@ant-design/icons';
import { formatPhoneNumber } from '../../utils/MascaraDeCampos';
import { useWhatsAppMensagens } from './useWhatsAppMensagens';
import { convertDataUSParaBrasilEHora } from '../../services/Conversores';
import { Button, Col, Divider, Modal, Row, Spin, Table, Tag, Typography } from 'antd';

const { Text, Title } = Typography;

const WhatsAppMensagens: React.FC = () => {
    const {
        data,
        columns,
        selectedRow,
        isModalOpen,
        loadingModal,
        loadingTable,
        refContagemDoFiltro,
        handleCancel,
    } = useWhatsAppMensagens();

    const propsState = useSelector((state: stateGlobal) => state.global);

    return (
        <>
            <Row>
                <Col span={24}>
                    <Title level={4}><WhatsAppOutlined style={{ fontSize: 25, marginRight: 10 }} />{"WhatsApp Mensagens"}</Title>
                    <Divider />
                </Col>
            </Row>
            <Table
                columns={columns}
                dataSource={data}
                rowKey={(record) => record.id}
                loading={loadingTable}
                size="small"
                scroll={{ x: 1000 }}
                onChange={(_, __, ___, extra) => {
                    refContagemDoFiltro.current = extra.currentDataSource;
                }}
                pagination={{
                    locale: { items_per_page: '' },
                    showSizeChanger: true,
                    defaultPageSize: 100,
                    pageSizeOptions: ['10', '20', '50', '100', '150', '200'],
                }}
                title={(registros) => (
                    <div style={{
                        backgroundColor: propsState.theme === 'light' ? '#FAFAFA' : '#1D1D1D',
                        padding: 10,
                        marginBottom: -8,
                        margin: -8,
                        textAlign: 'end',
                    }}>
                        <Text>
                            {`Mostrando: ${registros.length} de ${refContagemDoFiltro.current.length > 0 ? refContagemDoFiltro.current.length + ' em' : ''} um total de ${data.length}`}
                        </Text>
                    </div>
                )}

                footer={(registros) => (
                    <div style={{ textAlign: 'end' }}>
                        <Text>
                            {`Mostrando: ${registros.length} de ${refContagemDoFiltro.current.length > 0 ? refContagemDoFiltro.current.length + ' em' : ''} um total de ${data.length}`}
                        </Text>
                    </div>
                )}
            />
            <Modal
                centered
                title={
                    <span>
                        Mensagem de: <strong>{selectedRow?.nome}</strong>
                    </span>
                }
                open={isModalOpen}
                onCancel={handleCancel}
                footer={[
                    <Button
                        key="back"
                        type="primary"
                        onClick={handleCancel}
                        style={{
                            borderRadius: '6px'
                        }}
                    >
                        Fechar
                    </Button>
                ]}
            >
                <Spin spinning={loadingModal}>
                    {selectedRow ? (
                        <>
                            <Row>
                                <Col span={20}>
                                    <p><strong>Telefone:</strong> {formatPhoneNumber(selectedRow.telefone)}</p>
                                    <p><strong>Recebida em:</strong> {convertDataUSParaBrasilEHora(selectedRow.recebida_em)}</p>
                                    {selectedRow.usuario && selectedRow.status === 'Fechado' && (
                                        <p><strong>Fechado por:</strong> {selectedRow.usuario}</p>
                                    )}
                                </Col>
                                <Col span={4}>
                                    <Tag
                                        color={
                                            selectedRow.status === "Aberto" ? "blue" : selectedRow.status === "Fechado" ? "green" : "gray"
                                        }
                                    >
                                        {selectedRow.status.toUpperCase()}
                                    </Tag>
                                </Col>
                            </Row>
                            <hr />
                            <Col>
                                <p><strong>Mensagem:</strong></p>
                                <p>{selectedRow.conteudo}</p>
                            </Col>
                        </>
                    ) : (
                        <p>Nenhum dado selecionado.</p>
                    )}
                </Spin>
            </Modal>
        </>
    )
}

export default (WhatsAppMensagens);
